import checkCenter from './checkCenter/checkCenter.vue';
import checkRecord from './checkRecord/checkRecord.vue';
const manage = (resolve) => require(['@tiktok/pages/index/sensitiveWordManagement'], resolve);
import forbiddenWordCheck from './index.vue';

forbiddenWordCheck.childRoutes = [
    {
        path: 'checkCenter',
        name: 'checkCenter',
        component: checkCenter,
    },
    {
        path: 'checkRecord',
        name: 'checkRecord',
        component: checkRecord,
    },
    {
        path: 'manage',
        name: 'manage',
        component: manage,
    },
    {
        path: '/',
        redirect: 'checkCenter',
    },
];

export default forbiddenWordCheck;
